import { render, staticRenderFns } from "./Sdk.vue?vue&type=template&id=5b66ad6c&scoped=true"
import script from "./Sdk.vue?vue&type=script&lang=js"
export * from "./Sdk.vue?vue&type=script&lang=js"
import style0 from "./Sdk.vue?vue&type=style&index=0&id=5b66ad6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66ad6c",
  null
  
)

export default component.exports